import React, { lazy } from 'react';
import logger from '@/logger';
import mustache from 'mustache';
import { message } from 'antd';
import { store } from './redux/store';
import posthog from 'posthog-js';
import moment from 'moment-timezone';
import { appTargetName } from './appTargets';

export const sortByTime = field => (a, b) =>
	new Date(a[field || 'updated_at']) - new Date(b[field || 'updated_at']);

export const getAliasSignedUrl = url => {
	const baseUrl = 'storage.googleapis.com/bluebird-media-';
	const isProduction = url.includes('media-production') ? true : false;
	const newAlias = isProduction ? 'media.bpdev.club' : 'mediastaging.bpdev.club';
	const oldAlias = isProduction ? `${baseUrl}production` : `${baseUrl}staging`;
	const aliasedUrl = url.replace(oldAlias, newAlias);
	return aliasedUrl;
};
export function swapArrayElements(arr, i, j) {
	const b = arr[j];
	arr[j] = arr[i];
	arr[i] = b;
	return arr;
}

export function combineItems(arr, i, j) {
	const a = arr[i];
	const b = arr[j];
	const container = {
		component: 'View',
		props: {
			styleName: 'horizontal flexible',
		},
		children: [a, b],
	};
	arr.splice(j, 1);
	arr[i] = container;
	return arr;
}

export function childArrayFromPointer(array, pointers) {
	if (!pointers.length) return array;
	return childArrayFromPointer(array[pointers[0]], pointers.slice(1, pointers.length));
}

/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = path => {
	return reg.test(path);
};

export const urlToList = url => {
	const urllist = url.split('/').filter(i => i);
	return urllist.map((urlItem, index) => {
		return `/${urllist.slice(0, index + 1).join('/')}`;
	});
};

export function getDnDListStyle(isDragging, otherStyle) {
	return {
		...otherStyle,
		display: 'flex',
		flex: 1,
		backgroundColor: isDragging ? 'lightgreen' : 'transparent',
	};
}

export const GetURLParamValue = key => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	return urlParams.get(key);
};

export function getDnDItemStyle(isDragging, draggableStyle, otherStyle) {
	return {
		// some basic styles to make the items look a bit nicer
		attendeeSelect: 'none',
		// change background colour if dragging
		background: isDragging ? 'lightblue' : 'transparent',
		outline: isDragging ? '3px solid lightblue' : 'transparent',
		// styles we need to apply on draggables
		...draggableStyle,
		...otherStyle,
	};
}

// a little function to help us with reordering the result
export const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

export const move = (source, destination, droppableSource, droppableDestination) => {
	const sourceClone = Array.from(source);
	const destClone = Array.from(destination);
	const [removed] = sourceClone.splice(droppableSource.index, 1);

	destClone.splice(droppableDestination.index, 0, removed);

	return [sourceClone, destClone];
};

export const metadataInject = (eventInfo, metadata) => {
	let result = eventInfo;
	const replacements = { '&lt;': '<', '&gt;': '>', '&#x2F;': '/' };

	if (metadata) {
		if (eventInfo && eventInfo.toString().indexOf('{{') > -1) {
			result = mustache.render(eventInfo, metadata);
			//unescapes html to render '/' correctly if metadata tag render to url
			if (result.includes('https')) result = mustache.render(`{${eventInfo}}`, metadata);
			result = result.replaceAll(/&lt;|&gt;|&#x2F;/g, matched => replacements[matched]);
		} else result = eventInfo;
	}

	return result;
};

export const isPPTorCSV = fileType => {
	const secondaryType = fileType && fileType.split('/')[1];
	return secondaryType.includes('csv') || secondaryType.includes('presentation');
};

export const getFileProps = ({
	signedUrlEndpoint,
	callback,
	listType = 'picture',
	multiple = false,
	isMedia = false,
	isFile = false,
	mimeType,
	mediaType,
}) => ({
	name: 'file',
	multiple,
	listType,
	accept: mimeType,
	maxCount: !multiple ? 1 : undefined,
	beforeUpload: file => {
		if (mediaType === 'ATTENDEE_MATERIAL' && isPPTorCSV(file.type)) {
			message.error('File type not accepted');
			return false;
		}
		if (!isMedia && !isFile) {
			const isImage = file.type.includes('image/');
			if (!isImage) {
				message.error('You can only upload image file!');
			}
			const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isLt2M) {
				message.error('Image must be smaller than 2MB!');
			}
			return isImage && isLt2M;
		} else return isMedia || isFile;
	},
	onChange: info => {
		let status = info.file.status;
		if (status === 'uploading') {
			const uploaded = info.file.percent;
			if (uploaded === 100) {
				info.file.status = 'done';
				status = 'done';
			}
		}
		if (status === 'done') {
			//message.success(`${info.file.name} file uploaded successfully.`);
		} else if (status === 'error') {
			message.error(`${info.file.name} file upload failed.`);
		}
	},

	customRequest: imgCustomReq(signedUrlEndpoint, callback),
});
export const getSignedURL = signedURL => async file => {
	const { auth0Token } = store.getState().auth;
	try {
		const resp = await fetch(signedURL, {
			method: 'PUT',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: `Bearer ${auth0Token}`,
			},
			body: JSON.stringify({
				name: new Date().getTime() + encodeURI(file.name),
				content_type: file.type,
			}),
		});
		const media = await resp.json();
		if (!media.signed_url) throw media;
		return media.signed_url;
	} catch (e) {
		logger.error(e, {
			location: 'utils.getSignedURL',
			message: 'Failed to get signed URL',
		});
	}
};

export const imgCustomReq = (signedUrlEndpoint, callback = undefined) => async utils => {
	const { file, onError, onProgress, onSuccess } = utils;
	try {
		// convert HEIC/HEIF file to a JPEG File
		const fileToUpload = await handleHeicFileForUpload(file);
		const signedUrl = await getSignedURL(signedUrlEndpoint)(fileToUpload);
		const aliasedSignedUrl = getAliasSignedUrl(signedUrl);
		const xhr = new window.XMLHttpRequest();
		xhr.open('PUT', signedUrl, true);
		xhr.onprogress = evt => {
			if (evt.lengthComputable) {
				// evt.loaded the bytes the browser received
				// evt.total the total bytes set by the header
				// jQuery UI progress bar to show the progress on screen
				var percent = (evt.loaded / evt.total) * 100;
				onProgress({ percent });
			} else {
				onProgress({ percent: 100 });
			}
		};
		xhr.onload = () => {
			const status = xhr.status;
			if (status === 200) {
				onProgress({ percent: 100 });
				onSuccess(
					{
						aliasedSignedUrl,
						file: fileToUpload,
					},
					xhr
				);
				if (callback) {
					callback(aliasedSignedUrl, fileToUpload);
				}
			} else {
				onError(new Error(`Upload failed with status ${status}`));
			}
		};
		xhr.onerror = err => {
			logger.error(new Error('Upload failed: network error'), {
				location: 'utils.imgCustomReq.xhr.onerror',
				message: 'Failed to upload file',
				xhr,
			});
			onError(err);
		};
		xhr.setRequestHeader('Content-Type', fileToUpload.type);
		xhr.setRequestHeader('Cache-Control', 'public, max-age=0');
		xhr.send(fileToUpload);
	} catch (e) {
		logger.error(e, {
			location: 'utils.imgCustomReq',
			message: 'Failed to upload file',
		});
	}
};

export const pluralize = (n, one, many = `${one}s`) =>
	`${n.toLocaleString('en-US')} ${n === 1 ? one : many}`;

export const capitalizeString = str => {
	if (str && str.length > 0) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	return str;
};

export const stylePropValidator = (key, val) => {
	const styleProps = {
		textAlign: ['auto', 'left', 'right', 'center', 'justify'],
		fontWeight: ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'],
		alignContent: ['flex-start', 'flex-end', 'center', 'stretch', 'space-between', 'space-around'],
		alignItems: ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
		alignSelf: ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
		flexDirection: ['row', 'row-reverse', 'column', 'column-reverse'],
		justifyContent: [
			'flex-start',
			'flex-end',
			'center',
			'stretch',
			'space-between',
			'space-around',
		],
		resizeMode: ['cover', 'contain', 'stretch', 'repeat', 'center'],
		textTransform: ['none', 'uppercase', 'lowercase', 'capitalize'],
	};
	if (styleProps[key]) {
		const lowerCaseVal = val.toLowerCase();
		const foundVal = styleProps[key].filter(str => str === lowerCaseVal)[0];
		if (foundVal) return [key, String(foundVal)];
		return false;
	}
	return [key, String(val)];
};

export const getUrlFromHtmlScript = htmlString => {
	try {
		return htmlString.split('src=')[1].split(/'|"/)[1];
	} catch (error) {
		return null;
	}
};

export const hexToRGB = (h, opacity) => {
	try {
		let r = 0,
			g = 0,
			b = 0,
			a = opacity ? opacity : 1;

		if (h && h.length === 4) {
			r = '0x' + h[1] + h[1];
			g = '0x' + h[2] + h[2];
			b = '0x' + h[3] + h[3];
		} else if (h && h.length === 7) {
			r = '0x' + h[1] + h[2];
			g = '0x' + h[3] + h[4];
			b = '0x' + h[5] + h[6];
		}

		return 'rgba(' + +r + ',' + +g + ',' + +b + ',' + +a + ')';
	} catch (error) {
		logger.error(error, {
			location: 'utils.hexToRGB',
			message: 'Failed to convert hex to RGB',
		});
	}
};

export const validateNum = num => {
	const value = !num ? 0 : typeof num === 'string' ? num.trim() : num;
	const res = /^[0-9]+$/.test(value);
	return res;
};

export const tryParse = jsonStr => {
	if (typeof jsonStr === 'string') {
		try {
			return JSON.parse(jsonStr);
		} catch (error) {
			return jsonStr;
		}
	} else {
		return jsonStr;
	}
};

export const getLinkTarget = strOrObj => {
	// SWAN: transitioning from string onPress to obj onPress -- can remove string check after a while
	let linkTarget = '';
	const parsedStrOrObj = tryParse(strOrObj) || {};
	if (typeof parsedStrOrObj === 'string') {
		logger.warn('🚨 onPress has the wrong format 🚨', {
			location: 'utils.getLinkTarget',
			message: 'onPress has the wrong format, transitioning from string to object',
			strOrObj,
			parsedStrOrObj,
		});
		if (strOrObj && strOrObj.startsWith('/')) linkTarget = strOrObj;
	} else {
		if (parsedStrOrObj.link || parsedStrOrObj.route)
			linkTarget = parsedStrOrObj.link || parsedStrOrObj.route;
		else if (parsedStrOrObj.eventID) linkTarget = `Event ID #${parsedStrOrObj.eventID}`;
		else if (parsedStrOrObj.openApp)
			linkTarget = `Open App: ${appTargetName(parsedStrOrObj.openApp)}`;
	}
	return linkTarget;
};

export const displayEmail = email => {
	const parts = email.split('@');
	return email.length > 22 && parts.length === 2 ? (
		<div>
			{parts[0]}
			<wbr />@{parts[1]}
		</div>
	) : (
		<div>{email}</div>
	);
};

// reducer to reset default colors if color input is saved as empty
export const defaultColorsReducer = (obj, defaultsObj) =>
	Object.entries(obj).reduce((updatedObj, [key, val]) => {
		if (defaultsObj[key] && !val) updatedObj[key] = defaultsObj[key];
		else updatedObj[key] = val;
		return updatedObj;
	}, {});

export const sortMedia = (media, sortOrder) => {
	const currTime = new Date().toISOString();
	switch (sortOrder) {
		case 'lastUpdated':
			return media.sort((a, b) =>
				b.updated_at
					? b.updated_at.localeCompare(a.updated_at)
					: currTime.localeCompare(a.updated_at)
			);
		case 'lastAdded':
			return media.sort((a, b) =>
				b.created_at
					? b.created_at.localeCompare(a.created_at)
					: currTime.localeCompare(a.updated_at)
			);
		case 'alpha':
			return media.sort((a, b) => a.name.localeCompare(b.name));
		case 'type':
			return media.sort((a, b) => a.mime_type.localeCompare(b.mime_type));
		default:
			return media;
	}
};

export const getHeaders = () => {
	const { auth0Token } = store.getState().auth;
	return {
		headers: {
			'0Authorization': `Bearer ${auth0Token}`,
			'Content-Type': 'application/json',
		},
	};
};

export const captureEvent = (event, properties = {}) => {
	posthog.capture(event, properties);
};

export const formatTime = time => {
	const s = Math.ceil(time % 60);
	const hr = Math.floor(time / 3600);
	const min = Math.floor((time % 3600) / 60);

	return !min ? `${s}s` : `${hr ? hr + 'h ' : ''}${min}m`;
};

export const sortBuildNumbers = (buildNumbers, desc = false) => {
	return buildNumbers.sort((a, b) => {
		const partsA = a.split('.').map(Number);
		const partsB = b.split('.').map(Number);

		for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
			const partA = partsA[i] || 0;
			const partB = partsB[i] || 0;

			if (partA !== partB) {
				return desc ? partB - partA : partA - partB;
			}
		}
		return 0;
	});
};

export const shortenDescription = description => {
	if (description.length > 65) {
		return description.slice(0, 65) + '...';
	}
	return description;
};

export const formatDate = date => moment(date).format('ll');

export const DEFAULT_TIMEZONE = 'America/New_York';

export const getEventTimezone = event => {
	const timezone = event?.timezone;
	return timezone && moment.tz.names().includes(timezone) ? timezone : DEFAULT_TIMEZONE;
};

const zonedMoment = (timestamp, timezone) =>
	timestamp ? moment.tz(timestamp, timezone) : moment.tz(timezone);

// a zone has two abbreviations (EST/EDT); resolve against the date shown, not today
export const getTimezoneAbbreviation = (timezone, referenceDate) =>
	zonedMoment(referenceDate, timezone).format('z');

export const isSameWallClock = (timezoneA, timezoneB, referenceDate) => {
	const at = referenceDate ?? moment();
	return moment.tz(at, timezoneA).utcOffset() === moment.tz(at, timezoneB).utcOffset();
};

// everything a "times are in event time" affordance needs, resolved against the date on screen
export const getTimezoneContext = (event, referenceDate) => {
	const eventTimezone = getEventTimezone(event);
	const localTimezone = moment.tz.guess();
	return {
		eventTimezone,
		localTimezone,
		eventAbbreviation: getTimezoneAbbreviation(eventTimezone, referenceDate),
		localAbbreviation: getTimezoneAbbreviation(localTimezone, referenceDate),
		matchesLocalTime: isSameWallClock(eventTimezone, localTimezone, referenceDate),
	};
};

export const toEventTime = (event, timestamp) => zonedMoment(timestamp, getEventTimezone(event));

export const formatEventDateTime = (event, timestamp) =>
	toEventTime(event, timestamp).format('MM/DD/YYYY h:mm a z');

// antd pickers assume browser time, so event times pass through as the same local wall-clock
export const toEventWallClock = (event, timestamp) =>
	moment(toEventTime(event, timestamp).toArray());

export const fromEventWallClock = (event, wallClock) =>
	moment.tz(wallClock.toArray(), getEventTimezone(event));

/**
 * Helper function to handle lazy loading with retry.
 */
export const lazyWithReload = importer =>
	lazy(() => {
		return importer().catch(() => {
			return {
				default: () => {
					// Automatically reload the page if the there is an error
					setTimeout(() => {
						window.location.reload();
					}, 100);

					return null;
				},
			};
		});
	});

/**
 * If a marketing distinct ID is stored in local storage, this function will:
 *  1. Alias the authenticated user's ID (user.email) with the stored marketing distinct ID.
 *  2. Identify the user using the stored distinct ID so that subsequent events use it.
 *  3. Remove the stored distinct ID to avoid re-use.
 *
 * @param {Object} user - The authenticated user object; expected to have an `email` property.
 */
export function aliasAndIdentifyUserWithDistinctMarketingId({ email }) {
	const storedDistinctId = localStorage.getItem('marketingDistinctId');
	if (
		storedDistinctId &&
		typeof storedDistinctId === 'string' &&
		storedDistinctId.trim() !== '' &&
		storedDistinctId !== 'undefined'
	) {
		// Alias the authenticated user with the previously stored marketing distinct ID.
		posthog.alias(storedDistinctId, email);
		// Remove the marketing distinct ID after aliasing and identifying.
		localStorage.removeItem('marketingDistinctId');
	}
	posthog.identify(email, { email });
}

// Lazy load the heic-to module to avoid loading it unnecessarily.
let heicModulePromise;
const getHeicModule = async () => {
	if (!heicModulePromise) {
		heicModulePromise = import('heic-to/csp');
	}
	const { heicTo } = await heicModulePromise;
	return heicTo;
};

const checkIfHeicFile = file => {
	const type = file.type;
	const name = file.name?.toLowerCase() || '';
	return (
		type === 'image/heic' ||
		type === 'image/heif' ||
		name.endsWith('.heic') ||
		name.endsWith('.heif')
	);
};

// Converts HEIC/HEIF file to a JPEG File.
export const convertHeicToJpeg = async (file, quality = 0.8) => {
	const heicTo = await getHeicModule();
	const jpegBlob = await heicTo({
		blob: file,
		type: 'image/jpeg',
		quality,
	});
	const name = file.name.replace(/\.(heic|heif)$/i, '.jpg');
	return new File([jpegBlob], name, { type: 'image/jpeg' });
};

//  Returns the file to use for upload: converts to JPEG if HEIC/HEIF, otherwise returns the original file.
export const handleHeicFileForUpload = async file => {
	if (!file) return file;
	if (checkIfHeicFile(file)) {
		return convertHeicToJpeg(file);
	}
	return file;
};
